import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick", "onKeydown"]
const _hoisted_2 = { style: {"display":"inline-flex"} }
const _hoisted_3 = { class: "seven-steps-icon-container" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "seven-steps-info-right"
}
const _hoisted_7 = ["innerHTML"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SevenStepsElement',
  props: {
    icons: {},
    headers: {},
    contents: {}
  },
  setup(__props: any) {

const props = __props;



const activeIndex = ref(-1);

function toggleInfo (index: number) {
    activeIndex.value = activeIndex.value === index ? -1 : index;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.headers, (header, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "seven-steps-item"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["seven-steps-info-left", { active: activeIndex.value === index }]),
        tabindex: "0",
        role: "button",
        onClick: ($event: any) => (toggleInfo(index)),
        onKeydown: _withKeys(($event: any) => (toggleInfo(index)), ["enter"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (props.icons[index])
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "seven-steps-icon",
                  innerHTML: props.icons[index]
                }, null, 8 /* PROPS */, _hoisted_4))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("h3", {
            class: "seven-steps-header",
            innerHTML: header
          }, null, 8 /* PROPS */, _hoisted_5)
        ])
      ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1),
      (activeIndex.value === index)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              innerHTML: props.contents[index]
            }, null, 8 /* PROPS */, _hoisted_7)
          ]))
        : _createCommentVNode("v-if", true)
    ]))
  }), 128 /* KEYED_FRAGMENT */))
}
}

})